<script setup>
  import { defineProps } from 'vue'

  import InputGroup from '../InputGroup.vue';
  import { STAT_NAMES, STAT_NAMES_SHORT } from './constants.js';

  // const emit = defineEmits(['update:modelValue', 'change'])

  const props = defineProps({
    stat: String,
    step: {
      type: Number,
      default: 1,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: Number,
    setSingleStat: {
      type: Function,
      default: null
    }
  })

  const onChange = (newValue)=>{
    if (props.setSingleStat && !props.readonly){
      props.setSingleStat(props.stat, newValue)
    }
  };
</script>
<template>
  <InputGroup
    :class="'stat-input stat-input-'+props.stat"
    :input-class="'outline-stat-'+props.stat"
    :colour-class="'stat-'+props.stat"
    :label-class="'lg:w-[60%] '+(props.stat=='bst' ? 'text-white' : '')"
  >
    <template #label>
      <span class="hidden sm:block md:hidden xl:block whitespace-nowrap">{{ STAT_NAMES[props.stat] }}</span>
      <span class="block sm:hidden md:block xl:hidden">{{ STAT_NAMES_SHORT[props.stat] }}</span>
    </template>
    <template #input>
      <input
        type="number"
        pattern="[0-9]*"
        :step="props.step"
        min="0"
        :readonly="props.readonly"
        :value="props.value"
        :class="'lg:max-w-[40%] text-stat-'+props.stat"
        @input="onChange($event.target.value)"
      />
    </template>
  </InputGroup>
</template>
